import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

export const emptySepa = { account_holder: "", iban: "", consent: false };

const fmtIban = (v) => v.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 34).replace(/(.{4})/g, "$1 ").trim();

export function sepaValid(s) {
  return s.account_holder.trim().length >= 2 && /^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(s.iban.replace(/\s/g, "")) && s.consent;
}

export function SepaFields({ value, onChange, amount = "69,99", firstAmount = null }) {
  const set = (k) => (v) => onChange({ ...value, [k]: v });
  return (
    <div className="space-y-4" data-testid="sepa-fields">
      <div className="space-y-1.5">
        <Label htmlFor="sepa-holder" className="text-sm text-stone-600">Kontoinhaber</Label>
        <Input id="sepa-holder" value={value.account_holder} onChange={(e) => set("account_holder")(e.target.value)}
          data-testid="sepa-account-holder" placeholder="Vor- und Nachname bzw. Praxisname" className="h-12 rounded-xl" />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="sepa-iban" className="text-sm text-stone-600">IBAN</Label>
        <Input id="sepa-iban" value={value.iban} onChange={(e) => set("iban")(fmtIban(e.target.value))} autoComplete="off"
          data-testid="sepa-iban" placeholder="DE00 0000 0000 0000 0000 00" className="h-12 rounded-xl font-mono tracking-wide" />
      </div>
      <label className="flex items-start gap-3 p-4 rounded-2xl bg-stone-50 border border-stone-200 cursor-pointer">
        <Checkbox checked={value.consent} onCheckedChange={(c) => set("consent")(c === true)} data-testid="sepa-consent" className="mt-0.5" />
        <span className="text-xs text-stone-600 leading-relaxed" data-testid="sepa-mandate-text">
          <strong className="text-stone-800">SEPA-Lastschriftmandat:</strong> Ich ermächtige LAIzyDocu bzw. dessen Zahlungsdienstleister
          Mollie B.V., Zahlungen von meinem Konto mittels SEPA-Lastschrift einzuziehen
          ({firstAmount ? `erstmalig ${firstAmount} € für Einrichtung + 1. Zeitraum, danach ` : ""}alle 4 Wochen {amount} €). Zugleich weise ich
          mein Kreditinstitut an, die gezogenen Lastschriften einzulösen. Die Vorabankündigung erfolgt spätestens 1 Tag vor dem Einzug.
          Hinweis: Ich kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages
          verlangen. Es gelten dabei die mit meinem Kreditinstitut vereinbarten Bedingungen.
        </span>
      </label>
    </div>
  );
}
